import { Component, inject } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { ThemeService } from '@core/theme/theme.service';

@Component({
  selector: 'app-root',
  standalone: true,
  imports: [RouterOutlet],
  template: `<router-outlet />`,
})
export class App {
  // Language and text direction are applied by AppLanguageService during app
  // initialization — that has to happen before the first API request, which is
  // earlier than this component is created.
  private theme = inject(ThemeService); // Ensure theme service is initialized
}
